import React from "react";
import emailjs from "emailjs-com";
import './ContactMe.css';

const ContactMe = () => {
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_yyv8a2g', 'template_ow7c2z7', e.target, 'user_9IxxUymdRdJFJgd2Am2l3')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset()
    }
    return (
        <div className="fullContact">
            <div className="container" data-aos="zoom-out-up">
                <h2 className="text-center pt-5 display-3 getText">Get in Touch</h2>
                <form onSubmit={sendEmail}>
                    <div className="row pt-5 mx-auto">
                        <div className="col-8 form-group mx-auto ">
                            <input
                                type="text"
                                className="form-control frominput frominput"
                                placeholder="Name"
                                name="name"
                            />
                        </div>
                        <div className="col-8 form-group mx-auto">
                            <input
                                type="text"
                                className="form-control frominput"
                                placeholder="Email"
                                name="email"
                            />
                        </div>
                        <div className="col-8 form-group mx-auto">
                            <input
                                type="text"
                                className="form-control frominput"
                                placeholder="Subject"
                                name="subject"
                            />
                        </div>
                        <div className="col-8 form-group mx-auto">
                            <textarea
                                className="form-control frominput"
                                id=''
                                cols='30'
                                rows='8'
                                placeholder="Your Message"
                                name="message"
                            ></textarea>
                        </div>
                        <div className="col-8 form-group mx-auto sunmitBtn mt-4">
                            <input
                                type="submit"
                                className="form-control subBtn"
                                value="Send Mail"
                            />
                        </div>
                    </div>
                </form>
            </div>
            <div className="mt-5 pt-5">
                <h6 class="footerText text-center"><i class="fas fa-code"></i> with <i class="fas fa-heart"></i> by Tanjin Ahamed</h6>
            </div>
        </div>
    );
};

export default ContactMe;